import type { ReceiptTemplate } from '../schema';

export const goyardTemplate: ReceiptTemplate = {
  id: 'goyard',
  name: 'Goyard Receipt',
  brand: 'GOYARD',
  description: 'Goyard Paris luxury goods receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'goyard-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/goyard.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 18,
        addressLines: [
          'MAISON GOYARD',
          '233 RUE SAINT-HONORE',
          '75001 PARIS, FRANCE',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'goyard-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'trans', label: 'Transaction:', value: '847291' },
          { id: 'advisor', label: 'Advisor:', value: 'M. WAZOWSKI' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'time', label: 'Time:', value: '14:30' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'goyard-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'SAINT LOUIS PM TOTE', quantity: '1', price: '1650.00', sku: 'GY847291' },
          { id: '2', name: 'SENAT MM POUCH', quantity: '1', price: '850.00', sku: 'GY847292' },
        ],
        showQuantity: true,
        showSku: true,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'goyard-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '2500.00', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX (VAT)', value: '0.00', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '2500.00', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'goyard-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'AMEX ****7829',
        fields: [
          { id: 'auth', label: 'Authorization:', value: '059746' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'goyard-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'MERCI DE VOTRE VISITE\nTHANK YOU FOR YOUR VISIT',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

